export const text = {
  cvv: "CVV",
  pricing: "Pricing",
  creditCards: "Credit Cards",
  debitCards: "Debit Cards",
  saveCards: "Saved Cards",
  payNow: "Pay now",
  tryAgain: "Try Again",
  expirationDate: "Expiration Date (MM/YY)",
  cardNumber: "Enter Card Number",
  cardHolder: "Cardholder Name",
  paymentSuccessful: "Payment Successful",
  paymentFailed: "Payment Failed",
  paymentSummary: "Payment Summary",
  addCreditAndDebitCards: "Add Credit & Debit Cards",
  choosePaymentMode: "Payment Mode",
  savedPaymentOptions: "Saved payment options",
  creditAndDebitCards: "Credit and debit cards",
  saveThisCardToMakeYourPaymentsEasy:
    "Save this card to make your payments easy",
  viewMore: "View More",
  buyNow: "Buy Now",
  switchTo: "Switch To",
  saveThisCard: "Save this card for faster payment",
  payment: "Payment",
  completeTransaction: "Complete Your Transaction",
  payViaNewCard: "Pay Via New Card",
  addNewCard: "Add New Card",
};
